import { Flex, Input, InputProps, Typography, Upload, UploadProps } from 'antd'
import { RcFile } from 'antd/es/upload'
import React from 'react'
import { FieldError } from 'react-hook-form'
import ErrorText from 'src/app/shared/components/common/error-text'
import { FileChosenIcon } from 'src/assets/icons'
import './index.scss'

const { Dragger } = Upload

type BeforeUploadValueType = void | boolean | string | Blob | File

const CustomDraggableInput: React.FC<
  Omit<InputProps, 'value'> & {
    label?: string
    required?: boolean
    error?: FieldError
    value: any
    containerStyle?: React.CSSProperties
    uploadBtnText?: string
    hideUploadBtn?: boolean
    beforeUpload?: (
      file: RcFile,
      FileList: RcFile[],
      fromDrag?: boolean,
    ) => BeforeUploadValueType | Promise<BeforeUploadValueType>,
  } & UploadProps
> = (props) => {
  const {
    label,
    required,
    size = 'large',
    error,
    style,
    containerStyle,
    uploadBtnText,
    accept,
    hideUploadBtn = true,
    disabled,
    beforeUpload,
    ...etc
  } = props

  const isError = !!error?.message

  return (
    <div
      className={`custom-draggable-input ${disabled ? 'custom-draggable-input-disabled' : ''}`}
      style={{
        flex: 1,
        ...containerStyle,
      }}
    >
      <Typography.Text
        style={{ textAlign: 'left', fontSize: '14px', fontWeight: 700 }}
        className={`${required ? 'required' : ''} custom-select-label`}
      >
        {label}
      </Typography.Text>
      <Flex>
        <Dragger
          beforeUpload={(file, fileList) => {
            return beforeUpload?.(file, fileList, true)
          }}
          showUploadList={false}
          className='custom-drag-upload-btn'
          accept={accept}
        >
          <Input
            size={size}
            style={{
              marginBottom: error ? 4 : 0,
              marginTop: 4,
              ...style,
            }}
            className={`${isError ? 'error-input' : ''} ${hideUploadBtn ? 'upload-btn-hide' : 'upload-btn-show'}`}
            status={!!error ? 'error' : ''}
            addonBefore={<FileChosenIcon />}
            disabled={disabled}
            readOnly
            accept={accept}
            {...etc}
          />
        </Dragger>
        {(!hideUploadBtn || !disabled) && (
          <Upload
            className={`custom-upload-btn ${isError ? 'error-input-select' : ''} `}
            beforeUpload={beforeUpload}
            accept={accept}
            showUploadList={false}
          >
            {uploadBtnText}
          </Upload>
        )}
      </Flex>

      {error && <ErrorText>{error.message}</ErrorText>}
    </div>
  )
}

export default CustomDraggableInput
